import { render } from "./PrimeirosCards.vue?vue&type=template&id=76d21019&scoped=true"
import script from "./PrimeirosCards.vue?vue&type=script&lang=js"
export * from "./PrimeirosCards.vue?vue&type=script&lang=js"

import "./PrimeirosCards.vue?vue&type=style&index=0&id=76d21019&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d21019"]])

export default __exports__